<ui-grid [data]="data$ | async"
         [loading]="loading$ | async"
         [multiPageSelect]="true">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>

        <ui-header-button *ngIf="!isReviewMode"
                          type="main">
            <ng-template>
                <ng-container *ngIf="reportUrl$ | async as reportUrl">
                    <a [href]="reportUrl"
                       [matTooltip]="'transactions_grid_action_export' | translate"
                       [uiClickTrack]="'Action: Download Transaction Logs'"
                       (click)="downloadReport($event, reportUrl)"
                       mat-mini-fab
                       color="primary">
                        <mat-icon>file_download</mat-icon>
                    </a>
                </ng-container>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canPerformActionIf('Verified') || (loading$ | async)"
                        [uiClickTrack]="'Action: Grid: In Review'"
                        (click)="setState('InReview')"
                        mat-button
                        type="button">
                    {{ 'transaction_grid_action_in_review' | translate }}
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canPerformActionIf('InReview') || (loading$ | async)"
                        [uiClickTrack]="'Action: Grid: Mark as Verified'"
                        (click)="setState('Verified')"
                        mat-button
                        type="button">
                    {{ 'transaction_grid_action_mark_as_verified' | translate }}
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button *ngIf="!isReviewMode"
                          type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canSetReviewer() || (loading$ | async)"
                        (click)="setReviewer()"
                        mat-button
                        type="button">
                    {{ 'transaction_grid_action_assign_reviewer' | translate }}
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canPerformActionIf('InReview') || (loading$ | async)"
                        [uiClickTrack]="'Action: Grid: Retry Items'"
                        (click)="setState('Retried')"
                        mat-button
                        type="button">
                    {{ 'transaction_grid_action_retry_items' | translate }}
                </button>
            </ng-template>
        </ui-header-button>
        <ui-header-button type="action">
            <ng-template>
                <button [uiAuthorizeDisable]="'Transactions.Delete'"
                        [disableIf]="!canDelete() || (loading$ | async)"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeQueueItems()"
                        mat-button
                        type="button">
                    {{ 'transaction_grid_action_remove' | translate }}
                </button>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column *ngIf="isReviewMode"
                    [primary]="true"
                    [title]="'transaction_grid_queue' | translate"
                    property="queueDefinition.name"
                    width="15%">
        <ui-grid-search-filter [searchSourceFactory]="queueSuggest"
                               [disabled]="!(isQueuesViewGranted$ | async)"
                               property="queueDefinition.id">
        </ui-grid-search-filter>
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [title]="'transaction_grid_status' | translate"
                    [width]="!isReviewMode ? '9%' : '12%'"
                    property="status">
        <ng-template let-entry="data">
            {{ 'TransactionStatus_' + entry?.status | translate }}
        </ng-template>
        <ui-grid-dropdown-filter [items]="transactionStatus">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [searchable]="true"
                    [method]="'StartsWith'"
                    [title]="'transaction_grid_reference' | translate"
                    property="reference"
                    width="9%">
    </ui-grid-column>
    <ui-grid-column [title]="'transaction_grid_revision' | translate"
                    property="reviewStatus"
                    width="9%">
        <ng-template let-entry="data">
            {{ 'ReviewStatus_' + entry?.reviewStatus | translate }}
        </ng-template>
        <ui-grid-dropdown-filter [items]="options.review"
                                 [value]="reviewFilter">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [title]="'transaction_grid_priority' | translate"
                    [width]="!isReviewMode ? '9%' : '12%'"
                    property="priority">
        <ng-template let-entry="data">
            {{ 'PriorityType_' + entry?.priority | translate }}
        </ng-template>
        <ui-grid-dropdown-filter [items]="options.priority">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [title]="'transaction_grid_deadline' | translate"
                    [width]="!isReviewMode ? '9%' : '12%'"
                    property="dueDate">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #dueDateFormat
                           [matTooltip]="dueDateFormat?.dataset['title']"
                           [date]="entry.dueDate"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="!isReviewMode"
                    [title]="'transaction_grid_postpone' | translate"
                    property="deferDate"
                    width="9%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #deferDateFormat
                           [matTooltip]="deferDateFormat?.dataset['title']"
                           [date]="entry.deferDate"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="!isReviewMode"
                    [sortable]="true"
                    [title]="'transaction_grid_started' | translate"
                    property="startProcessing"
                    width="9%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #startProcessFormat
                           [matTooltip]="startProcessFormat?.dataset['title']"
                           [date]="entry.startProcessing"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="!isReviewMode"
                    [sortable]="true"
                    [title]="'transaction_grid_ended' | translate"
                    property="endProcessing"
                    width="9%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #endProcessFormat
                           [matTooltip]="endProcessFormat?.dataset['title']"
                           [date]="entry.endProcessing"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [searchable]="true"
                    [title]="'transaction_grid_robot' | translate"
                    [width]="!isReviewMode ? '10%' : '12%'"
                    property="robot.name">
        <ui-grid-search-filter [searchSourceFactory]="robotSuggest"
                               [disabled]="!(isRobotsViewGranted$ | async)"
                               property="robot.id">
        </ui-grid-search-filter>
    </ui-grid-column>
    <ui-grid-column *ngIf="!isReviewMode"
                    [searchable]="true"
                    [title]="'transaction_grid_reviewer' | translate"
                    property="reviewerUser.userName"
                    width="10%">
        <ui-grid-search-filter [searchSourceFactory]="reviewerSuggest"
                               [disabled]="!(isTransactionsEditGranted$ | async)"
                               property="reviewerUser.id">
        </ui-grid-search-filter>
    </ui-grid-column>
    <ui-grid-column [title]="'tranasction_grid_exception' | translate"
                    property="processingExceptionType"
                    width="18%">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry?.processingExceptionType">
                {{ 'ProcessingExceptionType_' + entry?.processingExceptionType | translate }}
            </ng-container>
        </ng-template>
        <ui-grid-dropdown-filter [items]="options.processingException">
        </ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column *ngIf="isReviewMode"
                    [sortable]="true"
                    [title]="'transaction_grid_time_of_failure' | translate"
                    property="endProcessing"
                    width="18%">
        <ng-template let-index="index"
                     let-entry="data">
            <ui-dateformat #endProcessFormat
                           [matTooltip]="endProcessFormat?.dataset['title']"
                           [date]="entry.endProcessing"
                           contentType="relative"></ui-dateformat>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column [visible]="false"
                    [sort]="'desc'"
                    property="id">
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-index="index"
                     let-entry="data">
            <button [matMenuTriggerFor]="menu"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [uiClickTrack]="'Action: Grid: View Details'"
                        (click)="showDetails(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon svgIcon="uipath:info"></mat-icon>
                    <span translate>transaction_grid_action_view_details_tooltip</span>
                </button>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canEdit(entry)"
                        [uiClickTrack]="'Action: Grid: Edit'"
                        (click)="edit(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon svgIcon="uipath:Edit"></mat-icon>
                    <span translate>transaction_grid_action_edit</span>
                </button>
                <button [uiAuthorizeDisable]="'Transactions.Create'"
                        [disableIf]="!canClone(entry)"
                        [uiClickTrack]="'Action: Grid: Clone'"
                        (click)="clone(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon svgIcon="uipath:Duplicate"></mat-icon>
                    <span translate>transaction_grid_action_clone</span>
                </button>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canPerformActionIf('Verified', entry)"
                        [uiClickTrack]="'Action: Grid: In Review'"
                        (click)="setState('InReview', entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon>assignment</mat-icon>
                    <span translate>transaction_grid_action_in_review</span>
                </button>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canPerformActionIf('InReview', entry)"
                        [uiClickTrack]="'Action: Grid: Mark as Verified'"
                        (click)="setState('Verified', entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon>check_circle_outline</mat-icon>
                    <span translate>transaction_grid_action_mark_as_verified </span>
                </button>
                <!--
                    using *ngIf affects order for keyboard nav [a11y]
                    TODO: remove if fix is merged
                    https://github.com/angular/material2/pull/11720
                -->
                <button [hidden]="isReviewMode"
                        [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="isReviewMode || !canSetReviewer(entry)"
                        [uiClickTrack]="'Action: Grid: Set Reviewer'"
                        (click)="setReviewer(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon>assignment_ind</mat-icon>
                    <span translate>transaction_grid_action_assign_reviewer </span>
                </button>
                <button [uiAuthorizeDisable]="'Transactions.Edit'"
                        [disableIf]="!canPerformActionIf('InReview', entry)"
                        [uiClickTrack]="'Action: Grid: Retry Items'"
                        (click)="setState('Retried', entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon>autorenew</mat-icon>
                    <span translate>transaction_grid_action_retry_item </span>
                </button>
                <button [uiAuthorizeDisable]="'Transactions.Delete'"
                        [disableIf]="!canDelete(entry) || (loading$ | async)"
                        [uiClickTrack]="'Action: Grid: Remove'"
                        (click)="removeQueueItems(entry)"
                        mat-menu-item
                        type="button"
                        color="warn">
                    <mat-icon svgIcon="uipath:Delete"></mat-icon>
                    <span translate>transaction_grid_action_remove</span>
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
